"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredIf = requiredIf;

function requiredIf(type, condition) {
  return function (props, propName, componentName) {
    if (typeof type !== "function") {
      return new Error("Invalid react-required-if prop type supplied to ".concat(componentName, ". Validation failed."));
    }

    if (typeof condition !== "function") {
      return new Error("Invalid react-required-if condition supplied to ".concat(componentName, ". Validation failed."));
    }

    var test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
}

;